<template>
  <div class="Dashboard">
    <NavMenu :nomeusuario="usuario.nome" :setores="usuario.setores" :genero="usuario.genero" />
    <router-view />
    <router-view name="conteudo"></router-view>
  </div>
</template>

<script>
//import UserService from "../services/user.service";
import NavMenu from "../components/NavMenu.vue";
import io from "socket.io-client";
export default {
  components: { NavMenu },
  name: "Dashboard",
  data() {
    return {
      usuario: "",
    };
  },
  mounted() {
    this.socket.on("webHookou", (mensagem) => {
      //notificar trasnferência de setor
      if ((typeof mensagem.status !== "undefined")
        && (mensagem.status === "mudarSetor")
        && this.usuario.setores.some((v) => mensagem.setor.indexOf(v) !== -1)) {
        this.notificarDesktop(
          "INTRANET - Líder - HelpDesk",
          "[TRANSFERÊNCIA] Para o Setor : " + mensagem.setor[0] + "\nCliente: " + mensagem.senderName)
        return;
      }
      // notifica se a mensagem nao for MINHA OU se nao estiver atendendo
      if (!mensagem.fromMe) {
        if (
          (!mensagem.fromMe || !mensagem.atendendo) &&
          (typeof mensagem.setor !== "undefined") && (mensagem.senderName !== null)
        ) {
          if (
            this.usuario.setores.some((v) => mensagem.setor.indexOf(v) !== -1)
          ) {
            this.notificarDesktop(
              "INTRANET - Líder - HelpDesk",
              "Setor: " + mensagem.setor[0] + "\nCliente: " + mensagem.senderName
            );
          }
        }
      }
    });
    this.$store.dispatch("infoUsuario").then(
      (userDB) => {
        this.usuario = userDB;
      },
      () => {
        this.$router.push("/");
      }
    );
  },
  created() {
    this.socket = io("https://www.contabilidadelider.com");
  },
  methods: {
    playNotificationSound() {
      // Cria uma nova instância de áudio com o arquivo MP3
      const audio = new Audio('https://contabilidadelider.com/intranet/imgs/notification.mp3');
      audio.play().catch(error => console.error("Erro ao tocar o som da notificação:", error));
    },
    notificarDesktop(titulo, msg) {
      if (
        !document.URL.includes("WhatsApp") ||
        document.visibilityState == "hidden" ||
        !document.hasFocus()
      ) {
        /*   alert( "Foco => " + (document.hasFocus()) + " Visibility => " + document.visibilityState + " Whats => " + document.URL.includes('WhatsApp'));
      if (!document.hasFocus() || document.visibilityState == "hidden" || !document.URL.includes("WhatsApp")) {
*/
        this.playNotificationSound();
        var img = "https://contabilidadelider.com/imports/logo.png";
        if (!("Notification" in window)) {
          alert("This browser does not support desktop notification");
        } else if (Notification.permission === "granted") {
          // If it's okay let's create a notification
          var novaMsgNot = new Notification(titulo, { body: msg, icon: img });
          novaMsgNot.onclick = function () {
            window.focus();
            window.open("/intranet/#/WhatsApp", "_self");
          };
        }

        // Otherwise, we need to ask the user for permission
        else if (Notification.permission !== "denied") {
          Notification.requestPermission().then(function (permission) {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
              var novaMsgNot = new Notification(titulo, {
                body: msg,
                icon: img,
              });
              novaMsgNot.onclick = function () {
                window.focus();
                window.open("/#/WhatsApp", "_self");
              };
            }
          });
        }
      }
    },
  },
};
</script>
